<template>
    <div class="qtTable">
        <slot/>
    </div>
</template>